import {jQuery} from "../boot";
import {apiPost} from "./SecuredAjax";
import {showToastError} from "./boostrapToast";

type UrlSupplier = (radio: HTMLInputElement) => string
type FormSupplier = (radio: HTMLInputElement) => any

export function tableRowRemoteRadio(radioInputs: JQuery, submitUrl: UrlSupplier, submitForm: FormSupplier) {
	function submit(radioInput: HTMLInputElement) {
		const parent = radioInput.parentElement;
		if (!parent) return;

		const inputs = parent.querySelectorAll('input');
		parent.classList.add('placeholder-glow');
		inputs.forEach(node => node.disabled = true);

		const url = submitUrl(radioInput);
		const form = submitForm(radioInput);

		apiPost(url, form)
			.then(res => {
				const currentValue = res.value;

				inputs.forEach(node => node.checked = node.value == currentValue);
				inputs.forEach(node => node.disabled = false);
				parent.classList.remove('placeholder-glow')
			})
			.catch(err => showToastError(err));
	}

	radioInputs.on('change', function () {
		submit(jQuery(this).get(0) as HTMLInputElement);
	});
}